// @ts-check
/* global __API_BASE__ */
import { useAuth } from './store.js';

export const API_BASE = /** @type {string} */ (
  // @ts-ignore - injected by Vite define
  typeof __API_BASE__ !== 'undefined' ? __API_BASE__ : 'http://localhost:8787'
);

/**
 * @param {string} path
 * @param {RequestInit} [init]
 */
export async function api(path, init = {}) {
  const token = useAuth.getState().token;
  const headers = new Headers(init.headers);
  headers.set('Content-Type', 'application/json');
  if (token) headers.set('Authorization', `Bearer ${token}`);
  const res = await fetch(`${API_BASE}${path}`, { ...init, headers });
  if (res.status === 401) {
    useAuth.getState().clear();
    throw new Error('unauthenticated');
  }
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`HTTP ${res.status}: ${text}`);
  }
  return res.json();
}
